import { combineReducers } from 'redux';
import { reducer as mapReducer } from './map';
import { reducer as aoiReducer } from './aoi';
import { reducer as poiReducer } from './poi';
import { reducer as locationReducer } from './location';
import { reducer as appReducer } from './app';

const rootReducer = combineReducers({
    aoi: aoiReducer,
    poi: poiReducer,
    map: mapReducer,
    location: locationReducer,
    app: appReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js